import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Text } from 'ilenia';
import { BusinessUnit } from '../../Model';

interface AccessErrorProps {
    businessUnit: BusinessUnit;
}

export const AccessError: React.FunctionComponent<AccessErrorProps> = ({ businessUnit }) => {
    return (
        <div className={css(styles.text, styles.textAfter)}>
            <Text id="login.accessError" interpolations={{ businessUnit: `${businessUnit.displayName} (${businessUnit.name?.identifying})` }}/>
        </div>
    );
};

const styles = StyleSheet.create({
    text: {
        backgroundColor: 'rgb(251, 209, 204)',
        color: 'rgb(27, 27, 33)',
        lineHeight: '1.6',
        overflow: 'hidden',
        padding: '16px',
        border: 'medium none',
        borderRadius: '2px',
        marginTop: '24px',
    },
    textAfter: {
        ':first-child + div': {
            marginTop: '0',
            paddingTop: '0',
        },
    },
});



// WEBPACK FOOTER //
// ./src/CommonUI/UI/AccessError.tsx